import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Club, ClubJSON } from '../Club/Club';
import { Federacion, FederacionJSON } from '../Federacion/Federacion';
import { Provincia, ProvinciaJSON } from '../Provincia/Provincia';
import { CampoJuegoTipo, CampoJuegoTipoJSON } from '../CampoJuegoTipo/CampoJuegoTipo';
import { CampoJuegoTipoPiso, CampoJuegoTipoPisoJSON } from '../CampoJuegoTipoPiso/CampoJuegoTipoPiso';
import {
  CampoJuegoTipoIluminacion,
  CampoJuegoTipoIluminacionJSON,
} from '../CampoJuegoTipoIluminacion/CampoJuegoTipoIluminacion';
import {
  CampoJuegoTipoTribuna,
  CampoJuegoTipoTribunaJSON,
} from '../CampoJuegoTipoTribuna/CampoJuegoTipoTribuna';
import { CampoJuego, CampoJuegoJSON } from './CampoJuego';

export interface ContextCampoJuego {
  federaciones: Federacion[];
  clubes: Club[];
  provincias: Provincia[];
  campoJuegoTipos: CampoJuegoTipo[];
  campoJuegoTiposPiso: CampoJuegoTipoPiso[];
  campoJuegoTiposIluminacion: CampoJuegoTipoIluminacion[];
  campoJuegoTiposTribuna: CampoJuegoTipoTribuna[];
}

export interface ContextCampoJuegoJSON {
  federaciones: FederacionJSON[];
  clubes: ClubJSON[];
  provincias: ProvinciaJSON[];
  campoJuegoTipos: CampoJuegoTipoJSON[];
  campoJuegoTiposPiso: CampoJuegoTipoPisoJSON[];
  campoJuegoTiposIluminacion: CampoJuegoTipoIluminacionJSON[];
  campoJuegoTiposTribuna: CampoJuegoTipoTribunaJSON[];
}

export class CampoJuegoSystem {
  private readonly base = '/campojuegos';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getCampoJuegoIdentifiedBy(id: string): Promise<CampoJuego> {
    const data = await this.requestHandler.get<CampoJuegoJSON>(`${this.base}/${id}`);
    return CampoJuego.fromJSON(data);
  }

  async getList(): Promise<CampoJuego[]> {
    const data = await this.requestHandler.get<CampoJuegoJSON[]>(`${this.base}`);
    return data.map((entity) => CampoJuego.fromJSON(entity));
  }

  async getListForDropdown(): Promise<CampoJuego[]> {
    const data = await this.requestHandler.get<CampoJuegoJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => CampoJuego.fromJSON(entity));
  }

  async getContext(): Promise<ContextCampoJuego> {
    const context = await this.requestHandler.get<ContextCampoJuegoJSON>(`${this.base}/context`);
    // return data.map((context) => {
    const _federaciones = context.federaciones.map((e) => Federacion.fromJSON(e));
    const _clubes = context.clubes.map((e) => Club.fromJSON(e));
    const _provincias = context.provincias.map((e) => Provincia.fromJSON(e));
    const _campoJuegoTipos = context.campoJuegoTipos.map((e) => CampoJuegoTipo.fromJSON(e));
    const _campoJuegoTiposPiso = context.campoJuegoTiposPiso.map((e) => CampoJuegoTipoPiso.fromJSON(e));
    const _campoJuegoTiposIluminacion = context.campoJuegoTiposIluminacion.map((e) =>
      CampoJuegoTipoIluminacion.fromJSON(e)
    );
    const _campoJuegoTiposTribuna = context.campoJuegoTiposTribuna.map((e) =>
      CampoJuegoTipoTribuna.fromJSON(e)
    );
    return {
      federaciones: _federaciones,
      clubes: _clubes,
      provincias: _provincias,
      campoJuegoTipos: _campoJuegoTipos,
      campoJuegoTiposPiso: _campoJuegoTiposPiso,
      campoJuegoTiposIluminacion: _campoJuegoTiposIluminacion,
      campoJuegoTiposTribuna: _campoJuegoTiposTribuna,
    };
    // });
  }

  async save(entity: CampoJuego) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<CampoJuegoJSON, CampoJuegoJSON>(this.base, data);
    return CampoJuego.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }

  async getCampoJuegoFedId(fedId: string): Promise<CampoJuego[]> {
    const data = await this.requestHandler.get<CampoJuegoJSON[]>(`${this.base}/by-fed/${fedId}`);
    return data.map((entity) => CampoJuego.fromJSON(entity));
  }
}
